module.exports = __webpack_public_path__ + "static/img/contact-c.adcef9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact-c.jpg
// module id = jnlO
// module chunks = 1